export const DIDS = "DIDS";

export const DID_STATUS = Object.freeze({
  AVAILABLE: "AVAILABLE",
});
